import React, { Component } from "react";

class RepackagingLogo extends Component {
  render() {
    return (
      <svg viewBox="52 5 260 260">
        <g transform="translate(100)">
          <path
            d="M2.978 8.358l-2.978-2.618 8.707-4.74 3.341 2.345 3.21-2.345 8.742 4.639-3.014 2.68.014.008 3 4.115-3 1.634v4.122l-9 4.802-9-4.802v-4.115l1 .544v2.971l7.501 4.002v-7.889l-2.501 3.634-9-4.893 2.978-4.094zm9.523 5.366v7.875l7.499-4.001v-2.977l-5 2.724-2.499-3.621zm-11.022-1.606l7.208 3.918 1.847-2.684-7.231-3.742-1.824 2.508zm11.989 1.247l1.844 2.671 7.208-3.927-1.822-2.498-7.23 3.754zm-9.477-4.525l8.01-4.43 7.999 4.437-7.971 4.153-8.038-4.16zm-2.256-2.906l2.106 1.851 7.16-3.953-2.361-1.657-6.905 3.759zm11.273-2.052l7.076 3.901 2.176-1.935-6.918-3.671-2.334 1.705z"
            transform="scale(7)"
          />
        </g>
        <g>
          <path
            d="M 11 2 L 11 18.0625 L 3.71875 10.78125 L 2.28125 12.21875 L 11.28125 21.21875 L 12 21.90625 L 12.71875 21.21875 L 21.71875 12.21875 L 20.28125 10.78125 L 13 18.0625 L 13 2 L 11 2 z"
            transform="scale(2) translate(50, 70)"
          />
          <path
            d="M 11 2 L 11 18.0625 L 3.71875 10.78125 L 2.28125 12.21875 L 11.28125 21.21875 L 12 21.90625 L 12.71875 21.21875 L 21.71875 12.21875 L 20.28125 10.78125 L 13 18.0625 L 13 2 L 11 2 z"
            transform="scale(2) translate(80, 80)"
          />
          <path
            d="M 11 2 L 11 18.0625 L 3.71875 10.78125 L 2.28125 12.21875 L 11.28125 21.21875 L 12 21.90625 L 12.71875 21.21875 L 21.71875 12.21875 L 20.28125 10.78125 L 13 18.0625 L 13 2 L 11 2 z"
            transform="scale(2) translate(110, 70)"
          />
        </g>
        <g>
          <path
            d="M2.978 8.358l-2.978-2.618 8.707-4.74 3.341 2.345 3.21-2.345 8.742 4.639-3.014 2.68.014.008 3 4.115-3 1.634v4.122l-9 4.802-9-4.802v-4.115l1 .544v2.971l7.501 4.002v-7.889l-2.501 3.634-9-4.893 2.978-4.094zm9.523 5.366v7.875l7.499-4.001v-2.977l-5 2.724-2.499-3.621zm-11.022-1.606l7.208 3.918 1.847-2.684-7.231-3.742-1.824 2.508zm11.989 1.247l1.844 2.671 7.208-3.927-1.822-2.498-7.23 3.754zm-9.477-4.525l8.01-4.43 7.999 4.437-7.971 4.153-8.038-4.16zm-2.256-2.906l2.106 1.851 7.16-3.953-2.361-1.657-6.905 3.759zm11.273-2.052l7.076 3.901 2.176-1.935-6.918-3.671-2.334 1.705z"
            transform="scale(2.5) translate(37, 75)"
          />
          <path
            d="M2.978 8.358l-2.978-2.618 8.707-4.74 3.341 2.345 3.21-2.345 8.742 4.639-3.014 2.68.014.008 3 4.115-3 1.634v4.122l-9 4.802-9-4.802v-4.115l1 .544v2.971l7.501 4.002v-7.889l-2.501 3.634-9-4.893 2.978-4.094zm9.523 5.366v7.875l7.499-4.001v-2.977l-5 2.724-2.499-3.621zm-11.022-1.606l7.208 3.918 1.847-2.684-7.231-3.742-1.824 2.508zm11.989 1.247l1.844 2.671 7.208-3.927-1.822-2.498-7.23 3.754zm-9.477-4.525l8.01-4.43 7.999 4.437-7.971 4.153-8.038-4.16zm-2.256-2.906l2.106 1.851 7.16-3.953-2.361-1.657-6.905 3.759zm11.273-2.052l7.076 3.901 2.176-1.935-6.918-3.671-2.334 1.705z"
            transform="scale(2.5) translate(62, 83)"
          />
          <path
            d="M2.978 8.358l-2.978-2.618 8.707-4.74 3.341 2.345 3.21-2.345 8.742 4.639-3.014 2.68.014.008 3 4.115-3 1.634v4.122l-9 4.802-9-4.802v-4.115l1 .544v2.971l7.501 4.002v-7.889l-2.501 3.634-9-4.893 2.978-4.094zm9.523 5.366v7.875l7.499-4.001v-2.977l-5 2.724-2.499-3.621zm-11.022-1.606l7.208 3.918 1.847-2.684-7.231-3.742-1.824 2.508zm11.989 1.247l1.844 2.671 7.208-3.927-1.822-2.498-7.23 3.754zm-9.477-4.525l8.01-4.43 7.999 4.437-7.971 4.153-8.038-4.16zm-2.256-2.906l2.106 1.851 7.16-3.953-2.361-1.657-6.905 3.759zm11.273-2.052l7.076 3.901 2.176-1.935-6.918-3.671-2.334 1.705z"
            transform="scale(2.5) translate(86, 75)"
          />
        </g>
      </svg>
    );
  }
}

export default RepackagingLogo;
